import { useContext, useEffect, useState } from 'react'
import { CCDLDatasetDownloadModalContext } from 'contexts/CCDLDatasetDownloadModalContext'

export const useCCDLDatasetDownloadModalContext = () => {
  const {
    showing,
    setShowing,
    modality,
    setModality,
    format,
    setFormat,
    includesMerged,
    setIncludesMerged,
    excludeMultiplexed,
    setExcludeMultiplexed,
    selectedDataset,
    isMergedObjectsAvailable,
    isMultiplexedAvailable,
    isDeepLinkError,
    modalityOptions,
    formatOptions,
    downloadDataset,
    setDownloadDataset,
    downloadableDataset,
    project,
    datasets,
    token
  } = useContext(CCDLDatasetDownloadModalContext)

  const isTokenReady = !token
  const isOptionsReady = datasets?.length > 1 && !!token && !downloadDataset
  const isDownloadReady = !!downloadableDataset && !!token

  const modalTitleAction =
    isTokenReady || isOptionsReady ? 'Download' : 'Downloading'
  const [modalTitle, setModalTitle] = useState(modalTitleAction)

  useEffect(() => {
    if (!selectedDataset) return

    const modalTitleResource = selectedDataset.ccdl_project_id
      ? 'Project'
      : `Portal-wide`

    const dataName =
      selectedDataset.format === 'METADATA' ? 'Sample Metadata' : 'Data'

    setModalTitle(
      `${modalTitleAction} ${modalTitleResource} ${dataName}`.trim()
    )
  }, [selectedDataset, modalTitleAction])

  return {
    showing,
    setShowing,
    modalTitle,
    isDownloadReady,
    isTokenReady,
    isOptionsReady,
    downloadDataset,
    setDownloadDataset,
    downloadableDataset,
    modality,
    setModality,
    format,
    setFormat,
    includesMerged,
    setIncludesMerged,
    excludeMultiplexed,
    setExcludeMultiplexed,
    selectedDataset,
    isMergedObjectsAvailable,
    isMultiplexedAvailable,
    isDeepLinkError,
    modalityOptions,
    formatOptions,
    project,
    datasets
  }
}
